import { render, staticRenderFns } from "./rhServiceCategories.vue?vue&type=template&id=0948177b"
import script from "./rhServiceCategories.vue?vue&type=script&lang=js"
export * from "./rhServiceCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports